/* eslint-disable */
// Parses the request body string into an object
import { LLC_ENVS } from './constants';

export const parseRequestBody = (requestBodyString) => {
  const params = new URLSearchParams(requestBodyString);
  const paramsObject = Object.fromEntries(params.entries());
  return paramsObject;
};

export const getHostName = () => {
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? 'https://www.homedepot.com'
      : window.location.origin;
  }
  return host;
};

export const isLLC = () => {
  if (typeof window !== 'undefined') {
    const host = getHostName();
    return LLC_ENVS.some(domain => host.includes(domain));
  }
  return false;
}

export const checkLocalStore = () => {
  let localStore;
  try {
    if (typeof window !== 'undefined') {
      const store = window?.THD_LOCALIZER_AUTO_INIT?.Localizer.getLocalizedStore();
      // example: {"storeId":"550","name":"White Rock","city":"Dallas","state":"TX","zipcode":"75218"}
      const {
        storeId, name, city, state, zipcode
      } = store;
      localStore = storeId;
    }
  } catch (err) {
    console.error(err);
  }
  return localStore;
};

export const localizeUser = () => {
  const currentLocalStore = checkLocalStore();
  console.log('current store: ', currentLocalStore);

  // check if localized
  if (!currentLocalStore && typeof window !== 'undefined') {
    window?.THD_LOCALIZER_AUTO_INIT?.Localizer.localize().then(function (localizerResponse) {
      console.log('now localized to: ', localizerResponse.getLocalizedStore());
    });
  }
};

export const updateDeliveryZip = (deliveryZip) => {
  const zipCodeRegex = /^\d{5}$/;
  if (typeof window === 'undefined' || !window?.THD_LOCALIZER_AUTO_INIT?.Localizer || !deliveryZip.match(zipCodeRegex)) {
    return Promise.resolve(false);
  }
  return new Promise((resolve, reject) => {
    window.THD_LOCALIZER_AUTO_INIT.Localizer.validateUSZipcode(deliveryZip,
      () => {
        window.THD_LOCALIZER_AUTO_INIT.Localizer.updateDeliveryZipcodeDetailsNoEvent(deliveryZip, "USER");
        resolve(true);
      }, // successCalback
      () => reject(false), // failureCallback
      () => reject(false), // errorCalllback
    )
  })
}

export const publishNewRelicCustomAttribute = ({ tagName, tagValue }) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger('cart.cartCustomTag', { tagName, tagValue });
  }
};
